import { useRequest } from 'features/request/useRequest';

import { bimDeleteContractObjectGql } from '../BimContractStructureRequests';

export const useBimDeleteContractObject = ({ onSuccess }: { onSuccess: () => void }) => {
    const [
        bimDeleteContractObjectData,
        bimDeleteContractObjectStatus,
        bimDeleteContractObjectError,
        bimDeleteContractObjectRequest,
    ] = useRequest({
        requestId: 'bimDeleteContractObject',
        query: bimDeleteContractObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    return {
        bimDeleteContractObjectData: bimDeleteContractObjectData?.bimDeleteContractObject,
        bimDeleteContractObjectStatus,
        bimDeleteContractObjectError,
        bimDeleteContractObjectRequest,
    };
};
